import React,  { useEffect, useState } from 'react';
import { useApi } from '../../hooks/useApi';
import { Donor, ApiDonor,  } from '../../models/Donor';
import DonorListItem from './DonorListItem';
import Spinner from '../../components/Spinner';


const Recommended = () => {
  const [ apiDonors, setApiDonors ] = useState<ApiDonor[]>([]);
  const { get, loading } = useApi();

  useEffect(() => {
    get({
      endpoint: `/api/v1/donors/recommended`,
      skipAuth: true,
      onSuccess: (res) => {
        setApiDonors(res?.data || []);
      },
      onError: (err) => {
        console.error(err.message);
      },
    });
  }, [ get ])

  const donorItems = apiDonors.map(apiDonor => {
    const donor = new Donor(apiDonor);

    return <DonorListItem key={ donor.userNo } donor={ donor } />
  });

  return (
      <section className="search_donor">
        <h2 className="main_title"><span>性病検査済みおすすめドナー</span></h2>
        <ul>
          { loading ? <Spinner centered /> : donorItems }
        </ul>
      </section>
  );
}

export default Recommended;
